/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_RunningInputs */

const cs_ebr_running = /** @type {(inputs: Ebr_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probíhá import…`)
};

const en_ebr_running = /** @type {(inputs: Ebr_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import running…`)
};

/**
* | output |
* | --- |
* | "Import running…" |
*
* @param {Ebr_RunningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_running = /** @type {((inputs?: Ebr_RunningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_RunningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_running(inputs)
	return cs_ebr_running(inputs)
});